import _ from "lodash";
import { validateDate } from "./validateDate";
import { OTHER } from "../components/constants";

const actionOnClassic = (invalidQuestions, questionId, valid) => {
  if (!valid) {
    if (invalidQuestions.indexOf(questionId) < 0) {
      invalidQuestions.push(questionId);
    }
  } else {
    const invalidQuestionIndex = invalidQuestions.indexOf(questionId);
    if (invalidQuestionIndex >= 0) {
      invalidQuestions.splice(invalidQuestionIndex, 1);
    }
  }
};

export const validateSingleQuestion = (
  expType,
  question,
  answers,
  invalidQuestions,
  answerContactRef,
  setCurrentQuestionValid = () => {}
) => {
  // we are validating hidden/PTL questions in the SurveyAnswers component
  if (
    question.required &&
    question.type !== "hidden" &&
    !question.formattingType
  ) {
    if (!answers[question.id] && answers[question.id] !== 0) {
      actionOnClassic(invalidQuestions, question.id, false);
      if (expType === "guided") {
        setCurrentQuestionValid(false);
        return false;
      }
    } else if (
      answers[question.id] &&
      Array.isArray(answers[question.id]) &&
      !answers[question.id].length
    ) {
      actionOnClassic(invalidQuestions, question.id, false);
      if (expType === "guided") {
        setCurrentQuestionValid(false);
        return false;
      }
    } else if (
      typeof answers[question.id] === "string" &&
      answers[question.id].trim().length <= 0
    ) {
      actionOnClassic(invalidQuestions, question.id, false);
      if (expType === "guided") {
        setCurrentQuestionValid(false);
        return false;
      }
    } else if (
      question.type === "matrix" &&
      question["matrixRow"].length != answers[question.id].length
    ) {
      actionOnClassic(invalidQuestions, question.id, false);
      if (expType === "guided") {
        setCurrentQuestionValid(false);
        return false;
      }
    } else if (
      (question.type === "radios" || question.type === "checkboxes") &&
      question.other === true
    ) {
      if (
        question.multiple === false &&
        answers[question.id] === OTHER &&
        !answers[question.otherQuestionId]
      ) {
        actionOnClassic(invalidQuestions, question.id, false);
        if (expType === "guided") {
          setCurrentQuestionValid(false);
          return false;
        }
      } else if (
        question.multiple === true &&
        answers[question.id].indexOf(OTHER) !== -1 &&
        !answers[question.otherQuestionId]
      ) {
        actionOnClassic(invalidQuestions, question.id, false);
        if (expType === "guided") {
          setCurrentQuestionValid(false);
          return false;
        }
      } else {
        actionOnClassic(invalidQuestions, question.id, true);
        if (expType === "guided") {
          setCurrentQuestionValid(true);
          return true;
        }
      }
    } else if (question.type === "contact_form") {
      let isValidContactForm = true;
      answers[question.id]?.answers?.forEach((question) => {
        if (question.required && !question.value) {
          isValidContactForm = false;
          return;
        }
      });
      actionOnClassic(invalidQuestions, question.id, isValidContactForm);
      if (expType === "guided") {
        setCurrentQuestionValid(isValidContactForm);
        return isValidContactForm;
      }
    } else if (question.type === "datetime") {
      const dateObj = answers[question.id];
      const validFlag = validateDate(dateObj, question, true);
      actionOnClassic(invalidQuestions, question.id, validFlag);
      if (expType === "guided") {
        setCurrentQuestionValid(validFlag);
        return validFlag;
      }
    } else if (question.type === "number") {
      const validNum =
        answers[question.id] >= question.range.min &&
        answers[question.id] <= question.range.max;
      actionOnClassic(invalidQuestions, question.id, validNum);
      if (expType === "guided") {
        setCurrentQuestionValid(validNum);
        return validNum;
      }
    } else if (question.type === "image") {
      const isValid = answers[question.id].length > 0;
      actionOnClassic(invalidQuestions, question.id, isValid);
      if (expType === "guided") {
        setCurrentQuestionValid(isValid);
        return isValid;
      }
    } else {
      actionOnClassic(invalidQuestions, question.id, true);
      if (expType === "guided") {
        setCurrentQuestionValid(true);
        return true;
      }
    }
  } else {
    if (question.type === "datetime") {
      const dateObj = answers[question.id];
      const validFlag = validateDate(dateObj, question, false);
      actionOnClassic(invalidQuestions, question.id, validFlag);
      if (expType === "guided") {
        setCurrentQuestionValid(validFlag);
        return validFlag;
      }
    } else if (question.type === "contact_form" && answerContactRef?.current) {
      const isValidContactForm = answerContactRef?.current?.validate(
        answers[question.id]
      );
      actionOnClassic(invalidQuestions, question.id, isValidContactForm);
      if (expType === "guided") {
        setCurrentQuestionValid(isValidContactForm);
        return isValidContactForm;
      }
    } else if (question.type === "number") {
      const validNum =
        answers[question.id] >= question.range.min &&
        answers[question.id] <= question.range.max;
      actionOnClassic(invalidQuestions, question.id, validNum);
      if (expType === "guided") {
        setCurrentQuestionValid(validNum);
        return validNum;
      }
    } else {
      actionOnClassic(invalidQuestions, question.id, true);
      if (expType === "guided") {
        setCurrentQuestionValid(true);
        return true;
      }
    }
  }
};

export const validateQuestions = (
  expType,
  questions,
  answers,
  invalidQuestions,
  answerContactRef
) => {
  const copyInvalidQuestions = _.cloneDeep(invalidQuestions);
  for (let question of questions) {
    validateSingleQuestion(
      expType,
      question,
      answers,
      copyInvalidQuestions,
      answerContactRef
    );
  }
  return [...new Set(copyInvalidQuestions)];
};
